import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../../../v2/components/ui/loadArtemisFonts';
import isUsingArtemisStyles from '../../../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../../../v2/style-helper/MediaQueries';

import setContrastColorBasedOnBackground from '../../../../v2/style-helper/setContrastColorBasedOnBackground';
import Spacing from '../../../../v2/style-helper/Spacing';
import Typography from '../../../../v2/style-helper/Typography';

export default createUseStyles({
  email: {
    padding: '0.2em',
    marginBottom: props => (props.isNewGuestUpdatedPage ? 28 : 21),
    fontSize: props => (props.isNewGuestUpdatedPage ? 17 : props.theme.base.fontSize),
    extend: props => ({
      ...(isUsingArtemisStyles && props.theme.typography?.[Typography.small])
      && loadArtemisFonts(props.theme.typography[Typography.small]),
      ...(props.isNewGuestUpdatedPage && isUsingArtemisStyles && props.theme.typography?.[Typography.body])
      && loadArtemisFonts(props.theme.typography[Typography.body]),
    }),
  },
  pointsMessage: {
    paddingBottom: 16,
  },
  list: props => props.newGuestUpdatedPage && {
    listStyleType: 'none',
    marginTop: 15,
    marginLeft: 0,
    marginBottom: 21,
    fontSize: props.theme.base.fontSize,
    fontWeight: 700,
    lineHeight: '21px',
    ...(isUsingArtemisStyles && props.theme.typography?.[Typography.small])
    && loadArtemisFonts(props.theme.typography[Typography.small], true),
    
    [MediaQueries.phone]: {
      marginTop: 0,
    },
  },
  listItem: props => props.newGuestUpdatedPage && {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 11,
  },
  loyaltyListItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 9,
  },
  listIcon: {
    fill: props => setContrastColorBasedOnBackground(props.theme.core.brand),
    backgroundColor: props => props.theme.core.brand,
    padding: 6,
    height: 25,
    minWidth: 25,
    borderRadius: '50%',
    marginRight: 23,
  },
  loyaltyIcon: {
    height: 34,
    minWidth: 34,
    marginRight: 12,
    position: 'relative',
    left: -6,
  },
  header: {
    marginBottom: Spacing.double,
    fontSize: 28,
  },
});
